import Image from 'next/image';
import React from 'react';

import CommonModal from '..';

interface GptImage2LaunchModalOptions {
  onClose?: () => void;
  onTryNow?: () => void;
}

const FEATURE_ICONS = [
  {
    key: 'realism',
    titleKey: 'home.gptImage2Promo.feature.realism.title',
    descriptionKey: 'home.gptImage2Promo.feature.realism.desc',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
          d="M10 2.5L11.683 6.634L16 8.317L11.683 10L10 14.134L8.317 10L4 8.317L8.317 6.634L10 2.5Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    key: 'text',
    titleKey: 'home.gptImage2Promo.feature.text.title',
    descriptionKey: 'home.gptImage2Promo.feature.text.desc',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
          d="M4.167 4.167H15.833V6.25H11.25V15.833H8.75V6.25H4.167V4.167Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    key: 'composition',
    titleKey: 'home.gptImage2Promo.feature.composition.title',
    descriptionKey: 'home.gptImage2Promo.feature.composition.desc',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
          d="M10 3.333C13.682 3.333 16.667 6.318 16.667 10C16.667 13.682 13.682 16.667 10 16.667C6.318 16.667 3.333 13.682 3.333 10C3.333 6.318 6.318 3.333 10 3.333ZM7.083 7.083C6.393 7.083 5.833 7.643 5.833 8.333C5.833 9.023 6.393 9.583 7.083 9.583C7.773 9.583 8.333 9.023 8.333 8.333C8.333 7.643 7.773 7.083 7.083 7.083ZM12.917 7.083C12.227 7.083 11.667 7.643 11.667 8.333C11.667 9.023 12.227 9.583 12.917 9.583C13.607 9.583 14.167 9.023 14.167 8.333C14.167 7.643 13.607 7.083 12.917 7.083ZM10 11.042C8.12 11.042 6.521 12.247 5.928 13.929C7.064 14.93 8.553 15.536 10 15.536C11.447 15.536 12.936 14.93 14.072 13.929C13.479 12.247 11.88 11.042 10 11.042Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

function GptImage2LaunchContent({
  t,
  onClose,
  onTryNow,
}: {
  t: (key: string) => string;
  onClose: () => void;
  onTryNow: () => void;
}) {
  return (
    <div className="relative flex w-full overflow-hidden  bg-white flex-row gap-[28px] p-[48px] ">
      <button
        type="button"
        onClick={onClose}
        className="absolute right-[10px] top-[10px] flex h-[28px] w-[28px] items-center justify-center rounded-full text-[#11111180] transition-colors  hover:text-[#111111]"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <div className="flex min-w-0 flex-1 flex-col ">
        <div className="w-fit inline-flex h-[28px] items-center rounded-[4px] gap-[4px] bg-[#EEF0FF] px-[10px] text-[12px] font-[600] uppercase tracking-[0.4px] text-[#5D6BFF]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
          >
            <path
              d="M6.71138 4.4046C6.76822 4.23226 6.79663 4.1461 6.84338 4.13006C6.8639 4.12314 6.88612 4.12314 6.90663 4.13006C6.95338 4.1461 6.9818 4.23226 7.03863 4.40506C7.27651 5.12785 7.39522 5.48947 7.6198 5.77593C7.72292 5.90793 7.84209 6.0271 7.97409 6.13022C8.26055 6.35481 8.62217 6.47397 9.34497 6.71139C9.51776 6.76822 9.60392 6.79664 9.61997 6.84339C9.62685 6.86391 9.62685 6.88612 9.61997 6.90664C9.60392 6.95339 9.51776 6.98181 9.34497 7.03864C8.62217 7.27652 8.26055 7.39522 7.97409 7.61981C7.84212 7.72317 7.72316 7.84213 7.6198 7.9741C7.39522 8.26056 7.27605 8.62218 7.03863 9.34497C6.9818 9.51777 6.95338 9.60393 6.90663 9.61997C6.88611 9.62686 6.8639 9.62686 6.84338 9.61997C6.79663 9.60393 6.76822 9.51777 6.71138 9.34497C6.47351 8.62218 6.3548 8.26056 6.13022 7.9741C6.02685 7.84214 5.90789 7.72317 5.77592 7.61981C5.48946 7.39522 5.12784 7.27606 4.40505 7.03864C4.23226 6.98181 4.14609 6.95339 4.13005 6.90664C4.12313 6.88612 4.12313 6.86391 4.13005 6.84339C4.14609 6.79664 4.23226 6.76822 4.40505 6.71139C5.12784 6.47351 5.48946 6.35481 5.77592 6.13022C5.90792 6.0271 6.02709 5.90793 6.13022 5.77593C6.3548 5.48947 6.47397 5.12785 6.71138 4.40506V4.4046ZM3.09926 2.93701C3.1373 2.82197 3.15609 2.76422 3.18726 2.75368C3.20101 2.7491 3.21567 2.7491 3.22942 2.75368C3.26059 2.76422 3.27984 2.82197 3.31742 2.93701C3.47601 3.41918 3.5553 3.66026 3.70471 3.85093C3.77346 3.93893 3.85321 4.01822 3.94121 4.08743C4.13188 4.23685 4.37296 4.3166 4.85513 4.47472C4.97017 4.51276 5.02792 4.53156 5.03846 4.56272C5.04305 4.57647 5.04305 4.59114 5.03846 4.60489C5.02792 4.63606 4.97017 4.65531 4.85513 4.69289C4.37296 4.85147 4.13188 4.93076 3.94121 5.08018C3.85321 5.14893 3.77392 5.22868 3.70471 5.31668C3.5553 5.50735 3.47601 5.74843 3.31742 6.2306C3.27938 6.34564 3.26059 6.40339 3.22942 6.41393C3.21575 6.41854 3.20093 6.41854 3.18726 6.41393C3.15609 6.40339 3.13684 6.34564 3.09926 6.2306C2.94067 5.74843 2.86138 5.50735 2.71196 5.31668C2.64297 5.22858 2.56356 5.14917 2.47546 5.08018C2.2848 4.93076 2.04371 4.85147 1.56155 4.69289C1.44651 4.65485 1.38876 4.63606 1.37821 4.60489C1.3736 4.59121 1.3736 4.5764 1.37821 4.56272C1.38876 4.53156 1.44651 4.51231 1.56155 4.47472C2.04371 4.31614 2.2848 4.23685 2.47546 4.08743C2.56346 4.01868 2.64276 3.93893 2.71196 3.85093C2.86138 3.66026 2.94113 3.41918 3.09926 2.93701ZM5.66134 1.49189C5.68426 1.42039 5.69663 1.38418 5.71634 1.37731C5.72482 1.37448 5.73399 1.37448 5.74247 1.37731C5.76171 1.38418 5.77363 1.42039 5.79746 1.49189C5.89646 1.79347 5.94596 1.94381 6.03946 2.06343C6.08255 2.11843 6.13205 2.16793 6.18705 2.21101C6.30621 2.30451 6.45746 2.35401 6.75859 2.45301C6.83055 2.47685 6.8663 2.48876 6.87317 2.50801C6.87614 2.51663 6.87614 2.52599 6.87317 2.5346C6.8663 2.55385 6.83055 2.56576 6.75859 2.5896C6.45701 2.6886 6.30667 2.7381 6.18705 2.8316C6.13205 2.87468 6.08255 2.92418 6.03946 2.97918C5.94596 3.09835 5.89646 3.2496 5.79746 3.55072C5.77363 3.62268 5.76171 3.65843 5.74247 3.66531C5.73385 3.66824 5.7245 3.66824 5.71588 3.66531C5.69663 3.65843 5.68471 3.62268 5.66088 3.55072C5.56188 3.24914 5.51238 3.09881 5.41888 2.97918C5.37581 2.92422 5.32626 2.87466 5.2713 2.8316C5.15213 2.7381 5.00088 2.6886 4.69976 2.5896C4.6278 2.56576 4.59205 2.55385 4.58517 2.5346C4.58224 2.52598 4.58224 2.51663 4.58517 2.50801C4.59205 2.48876 4.6278 2.47685 4.69976 2.45301C5.00134 2.35401 5.15167 2.30451 5.2713 2.21101C5.32626 2.16795 5.37581 2.11839 5.41888 2.06343C5.51238 1.94426 5.56188 1.79301 5.66088 1.49189H5.66134Z"
              fill="#6365FF"
            />
          </svg>
          {t('home.gptImage2Promo.badge')}
        </div>

        <h2 className="mt-[34px] text-[44px] font-[600] leading-[42px] tracking-[0.8px] text-[#111111] ">
          {t('home.gptImage2Promo.titlePrefix')}
          <br />
          <span className="bg-[linear-gradient(90deg,#4A7DFF_0%,#8A5CFF_100%)] bg-clip-text text-transparent">
            {t('home.gptImage2Promo.titleHighlight')}
          </span>
        </h2>

        <p className="mt-[14px] max-w-[360px] text-[14px] leading-[20px] text-[#11111199]">
          {t('home.gptImage2Promo.desc')}
        </p>

        <div className="mt-[34px] flex flex-col gap-[18px]">
          {FEATURE_ICONS.map((feature) => (
            <div key={feature.key} className="flex items-start gap-[14px]">
              <div className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-[14px] bg-[#EEF0FF] text-[#6B63FF]">
                {feature.icon}
              </div>
              <div className="min-w-0">
                <div className="text-[16px] font-[600] leading-[22px] text-[#111111]">
                  {t(feature.titleKey)}
                </div>
                <div className="mt-[4px] text-[12px] leading-[16px] text-[#11111180]">
                  {t(feature.descriptionKey)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={onTryNow}
          className="group mt-[32px] h-[48px] w-fit flex items-center justify-center rounded-[8px] bg-[#4931FA] px-[18px] text-[14px] font-[500] text-white"
        >
          {t('home.gptImage2Promo.cta')}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className="ml-0 w-0 shrink-0 overflow-hidden opacity-0 transition-all duration-200 group-hover:ml-[8px] group-hover:w-[24px] group-hover:opacity-100"
          >
            <path
              d="M21 12L16 7M21 12L16 17M21 12H3"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="relative rounded-[24px] overflow-hidden ">
        <Image src="/images/gpt-image-activity.png" alt="" width={416} height={484} />
      </div>
    </div>
  );
}

export function gptImage2LaunchModalShow(options: GptImage2LaunchModalOptions = {}) {
  CommonModal.show((t) => ({
    width: 936,
    modalClassName: 'gpt-image2-launch-modal',
    contentWrapperClassName: 'gpt-image2-launch-modal-content',
    customPadding: {
      x: 0,
      y: 0,
    },
    footer: false,
    title: null,
    requireLogin: true,
    content: (close) => (
      <GptImage2LaunchContent
        t={t}
        onClose={() => {
          close();
          options.onClose?.();
        }}
        onTryNow={() => {
          close();
          options.onTryNow?.();
        }}
      />
    ),
  }));
}
